import { Waves } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useDiveLakes, useMeFeatures } from "../api/hooks.ts";
import { useLocale } from "../i18n/index.ts";

/**
 * "Dive mode (beta)" button on the spot page. Renders nothing (and takes no space) for anyone
 * without dive access or when the spot's lake has no tile set. Mount it only for signed-in
 * viewers: it asks `/api/me/features`.
 */
export function DiveEntry({ lakeSlug, spotSlug }: { lakeSlug: string | null; spotSlug: string }) {
  const { t } = useTranslation();
  const locale = useLocale();
  const { dive } = useMeFeatures();
  const lakes = useDiveLakes(dive && lakeSlug !== null);
  if (!dive || !lakeSlug || !lakes.data?.some((l) => l.slug === lakeSlug)) return null;
  return (
    <Link
      className="ds-btn ds-btn--tinted"
      to={`/${locale}/dive/${encodeURIComponent(lakeSlug)}?from=${encodeURIComponent(spotSlug)}`}
    >
      <Waves aria-hidden="true" strokeWidth={1.75} />
      {t("diveAccess.button")}
    </Link>
  );
}
